import {
  Supplier,
  PurchaseRequisition,
  PurchaseOrder,
  Product,
  Requisition,
  ReceiveEntry,
  QCEntry,
  ProcurementApproval,
  StockEntry,
  StockTransfer,
  PublishedTender,
  SupplierRFP,
  MasterDataItem,
} from '../types'

export const mockSuppliers: Supplier[] = [
  {
    id: '1',
    code: 'SUP-001',
    name: 'TechCorp Solutions',
    type: 'Firm',
    category: 'Service',
    businessType: 'Limited',
    countryOfOrigin: 'USA',
    businessOperationCountry: 'Global',
    localInternational: 'International',
    website: 'https://techcorp.example.com',
    communicationAddress: '123 Tech Blvd, Silicon Valley, CA',
    contactPersonName: 'John Doe',
    mobile: '+1-555-0101',
    email: 'john@techcorp.example.com',
    authorizedPersonName: 'Jane Smith',
    authorizedEmail: 'jane@techcorp.example.com',
    authorizedPhone: '+1-555-0102',
    bankName: 'Global Bank',
    branchName: 'SV Branch',
    accountName: 'TechCorp Solutions LLC',
    accountNumber: '100200300',
    swiftCode: 'GLBBUS33',
    contractExpiry: '2026-12-31',
    deliveryDelayPercent: 2,
    rejectionRatePercent: 1,
    totalDeliveries: 48,
    onTimeDeliveries: 45,
    delayedDeliveries: 2,
    pendingDeliveries: 1,
    totalItemsInspected: 520,
    itemsAccepted: 512,
    itemsRejected: 5,
    itemsUnderReview: 3,
    kpiScore: 90,
    ratingPercentage: 90,
    performanceStatus: 'Excellent',
    status: 'Active',
  },
  {
    id: '2',
    code: 'SUP-002',
    name: 'Office Supplies Co.',
    type: 'Firm',
    category: 'Goods',
    businessType: 'Sole Proprietorship',
    countryOfOrigin: 'UK',
    businessOperationCountry: 'UK',
    localInternational: 'Local',
    communicationAddress: '45 High St, London',
    contactPersonName: 'Alice Johnson',
    mobile: '+44-7700-900000',
    email: 'alice@officesupplies.example.com',
    authorizedPersonName: 'Alice Johnson',
    authorizedEmail: 'alice@officesupplies.example.com',
    authorizedPhone: '+44-7700-900000',
    bankName: 'UK Trust Bank',
    branchName: 'City Center',
    accountName: 'Office Supplies Co.',
    accountNumber: '400500600',
    swiftCode: 'UKTBGB22',
    contractExpiry: '2025-06-15',
    deliveryDelayPercent: 4,
    rejectionRatePercent: 2,
    totalDeliveries: 35,
    onTimeDeliveries: 32,
    delayedDeliveries: 2,
    pendingDeliveries: 1,
    totalItemsInspected: 380,
    itemsAccepted: 368,
    itemsRejected: 8,
    itemsUnderReview: 4,
    kpiScore: 80,
    ratingPercentage: 80,
    performanceStatus: 'Good',
    status: 'Active',
  },
  {
    id: '3',
    code: 'SUP-003',
    name: 'BuildIt Construction',
    type: 'Firm',
    category: 'Works',
    businessType: 'Limited',
    countryOfOrigin: 'Canada',
    businessOperationCountry: 'Canada',
    localInternational: 'Local',
    communicationAddress: '789 Industrial Pkwy, Toronto',
    contactPersonName: 'Bob Builder',
    mobile: '+1-416-555-0199',
    email: 'bob@buildit.example.com',
    authorizedPersonName: 'Robert Builder',
    authorizedEmail: 'robert@buildit.example.com',
    authorizedPhone: '+1-416-555-0199',
    bankName: 'Maple Leaf Bank',
    branchName: 'Downtown',
    accountName: 'BuildIt Construction Inc.',
    accountNumber: '700800900',
    swiftCode: 'MLBCACCT',
    contractExpiry: '2026-09-30',
    deliveryDelayPercent: 8,
    rejectionRatePercent: 3,
    totalDeliveries: 12,
    onTimeDeliveries: 8,
    delayedDeliveries: 3,
    pendingDeliveries: 1,
    totalItemsInspected: 85,
    itemsAccepted: 75,
    itemsRejected: 6,
    itemsUnderReview: 4,
    kpiScore: 64,
    ratingPercentage: 64,
    performanceStatus: 'Average',
    status: 'Pending',
  },
  {
    id: '4',
    code: 'SUP-004',
    name: 'Global Logistics',
    type: 'Firm',
    category: 'Others',
    businessType: 'Limited',
    countryOfOrigin: 'Germany',
    businessOperationCountry: 'EU',
    localInternational: 'International',
    communicationAddress: '10 Autobahn, Berlin',
    contactPersonName: 'Hans Muller',
    mobile: '+49-151-555-0100',
    email: 'hans@globallogistics.example.com',
    authorizedPersonName: 'Hans Muller',
    authorizedEmail: 'hans@globallogistics.example.com',
    authorizedPhone: '+49-151-555-0100',
    bankName: 'Deutsche Bank',
    branchName: 'Berlin Central',
    accountName: 'Global Logistics GmbH',
    accountNumber: '1122334455',
    swiftCode: 'DEUTDEBB',
    contractExpiry: '2024-03-01',
    deliveryDelayPercent: 15,
    rejectionRatePercent: 6,
    totalDeliveries: 22,
    onTimeDeliveries: 15,
    delayedDeliveries: 5,
    pendingDeliveries: 2,
    totalItemsInspected: 180,
    itemsAccepted: 160,
    itemsRejected: 12,
    itemsUnderReview: 8,
    kpiScore: 31,
    ratingPercentage: 31,
    performanceStatus: 'Poor',
    status: 'Blacklisted',
  },
  {
    id: '5',
    code: 'SUP-005',
    name: 'MedEquip International',
    type: 'Firm',
    category: 'Goods',
    businessType: 'Limited',
    countryOfOrigin: 'Japan',
    businessOperationCountry: 'Asia-Pacific',
    localInternational: 'International',
    website: 'https://medequip.example.jp',
    communicationAddress: '5-2 Shibuya, Tokyo 150-0002',
    contactPersonName: 'Yuki Tanaka',
    mobile: '+81-90-1234-5678',
    email: 'yuki@medequip.example.jp',
    authorizedPersonName: 'Kenji Sato',
    authorizedEmail: 'kenji@medequip.example.jp',
    authorizedPhone: '+81-90-8765-4321',
    bankName: 'Mizuho Bank',
    branchName: 'Shibuya Branch',
    accountName: 'MedEquip International Co. Ltd.',
    accountNumber: '5566778899',
    swiftCode: 'MHCBJPJT',
    contractExpiry: '2027-03-15',
    deliveryDelayPercent: 1,
    rejectionRatePercent: 1,
    totalDeliveries: 18,
    onTimeDeliveries: 17,
    delayedDeliveries: 1,
    pendingDeliveries: 0,
    totalItemsInspected: 95,
    itemsAccepted: 93,
    itemsRejected: 1,
    itemsUnderReview: 1,
    kpiScore: 93,
    ratingPercentage: 93,
    performanceStatus: 'Excellent',
    status: 'Active',
  },
  {
    id: '6',
    code: 'SUP-006',
    name: 'GreenEnergy Solutions',
    type: 'Firm',
    category: 'Service',
    businessType: 'Limited',
    countryOfOrigin: 'Australia',
    businessOperationCountry: 'Australia',
    localInternational: 'Local',
    website: 'https://greenenergy.example.au',
    communicationAddress: '88 Solar Ave, Sydney NSW 2000',
    contactPersonName: 'Emma Clarke',
    mobile: '+61-400-123-456',
    email: 'emma@greenenergy.example.au',
    authorizedPersonName: 'Liam Clarke',
    authorizedEmail: 'liam@greenenergy.example.au',
    authorizedPhone: '+61-400-654-321',
    bankName: 'Commonwealth Bank',
    branchName: 'Sydney CBD',
    accountName: 'GreenEnergy Solutions Pty Ltd',
    accountNumber: '9988776655',
    swiftCode: 'OCBCSGSG',
    contractExpiry: '2025-01-10',
    deliveryDelayPercent: 5,
    rejectionRatePercent: 1,
    totalDeliveries: 28,
    onTimeDeliveries: 25,
    delayedDeliveries: 2,
    pendingDeliveries: 1,
    totalItemsInspected: 210,
    itemsAccepted: 205,
    itemsRejected: 3,
    itemsUnderReview: 2,
    kpiScore: 81,
    ratingPercentage: 81,
    performanceStatus: 'Good',
    status: 'Active',
  },
  {
    id: '7',
    code: 'SUP-007',
    name: 'SafeGuard Security',
    type: 'Firm',
    category: 'Service',
    businessType: 'Sole Proprietorship',
    countryOfOrigin: 'India',
    businessOperationCountry: 'India',
    localInternational: 'Local',
    communicationAddress: '42 MG Road, Bangalore 560001',
    contactPersonName: 'Rajesh Kumar',
    mobile: '+91-98765-43210',
    email: 'rajesh@safeguard.example.in',
    authorizedPersonName: 'Rajesh Kumar',
    authorizedEmail: 'rajesh@safeguard.example.in',
    authorizedPhone: '+91-98765-43210',
    bankName: 'State Bank of India',
    branchName: 'MG Road Branch',
    accountName: 'SafeGuard Security Services',
    accountNumber: '3344556677',
    swiftCode: 'BOFAUS3N',
    contractExpiry: '2026-06-30',
    deliveryDelayPercent: 9,
    rejectionRatePercent: 3,
    totalDeliveries: 42,
    onTimeDeliveries: 35,
    delayedDeliveries: 5,
    pendingDeliveries: 2,
    totalItemsInspected: 310,
    itemsAccepted: 295,
    itemsRejected: 10,
    itemsUnderReview: 5,
    kpiScore: 61,
    ratingPercentage: 61,
    performanceStatus: 'Average',
    status: 'Active',
  },
  {
    id: '8',
    code: 'SUP-008',
    name: 'TechHardware Inc.',
    type: 'Firm',
    category: 'Goods',
    businessType: 'Limited',
    countryOfOrigin: 'USA',
    businessOperationCountry: 'Global',
    localInternational: 'International',
    website: 'https://techhardware.example.com',
    communicationAddress: '1234 Tech Drive, Austin, TX 78701',
    contactPersonName: 'David Chen',
    mobile: '+1-555-0202',
    email: 'david@techhardware.example.com',
    authorizedPersonName: 'David Chen',
    authorizedEmail: 'david@techhardware.example.com',
    authorizedPhone: '+1-555-0202',
    bankName: 'Global Bank',
    branchName: 'Austin Branch',
    accountName: 'TechHardware Inc.',
    accountNumber: '1122334455',
    swiftCode: 'THINCUS33',
    contractExpiry: '2025-12-31',
    deliveryDelayPercent: 20,
    rejectionRatePercent: 8,
    totalDeliveries: 15,
    onTimeDeliveries: 10,
    delayedDeliveries: 4,
    pendingDeliveries: 1,
    totalItemsInspected: 120,
    itemsAccepted: 100,
    itemsRejected: 15,
    itemsUnderReview: 5,
    kpiScore: 8,
    ratingPercentage: 8,
    performanceStatus: 'Poor',
    status: 'Active',
  },
  {
    id: '9',
    code: 'SUP-009',
    name: 'Global Services Ltd.',
    type: 'Firm',
    category: 'Service',
    businessType: 'Limited',
    countryOfOrigin: 'UK',
    businessOperationCountry: 'Global',
    localInternational: 'International',
    website: 'https://globalservices.example.com',
    communicationAddress: '567 Global Ave, London, UK',
    contactPersonName: 'Sarah Wilson',
    mobile: '+44-7700-900001',
    email: 'sarah@globalservices.example.com',
    authorizedPersonName: 'Sarah Wilson',
    authorizedEmail: 'sarah@globalservices.example.com',
    authorizedPhone: '+44-7700-900001',
    bankName: 'UK Trust Bank',
    branchName: 'City Center',
    accountName: 'Global Services Ltd.',
    accountNumber: '9988776655',
    swiftCode: 'GSLUK22',
    contractExpiry: '2026-06-30',
    deliveryDelayPercent: 3,
    rejectionRatePercent: 2,
    totalDeliveries: 30,
    onTimeDeliveries: 28,
    delayedDeliveries: 1,
    pendingDeliveries: 1,
    totalItemsInspected: 250,
    itemsAccepted: 240,
    itemsRejected: 6,
    itemsUnderReview: 4,
    kpiScore: 83,
    ratingPercentage: 83,
    performanceStatus: 'Good',
    status: 'Active',
  },
]

export const mockPRs: PurchaseRequisition[] = [
  {
    id: '1',
    prNo: 'PR-2023-001',
    originator: 'Sarah Connor',
    departmentCode: 'IT-01',
    project: 'PRJ-IT-100',
    priority: 'High',
    estimatedDeliveryDate: '2023-11-15',
    requisitionFor: 'Goods',
    procurementMethod: 'Direct Purchase',
    lineItems: [
      {
        id: 'l1',
        product: 'Laptop Pro X',
        qty: 5,
        rate: 1200,
        estimatedCost: 6000,
        specification: '16GB RAM, 512GB SSD',
      },
    ],
    total: 6000,
    budgetAllocated: 50000,
    budgetAvailable: 44000,
    status: 'Approved',
    submissionDate: '2023-10-01',
  },
  {
    id: '2',
    prNo: 'PR-2023-002',
    originator: 'Mike Ross',
    departmentCode: 'HR-02',
    project: 'PRJ-HR-200',
    priority: 'Medium',
    estimatedDeliveryDate: '2023-12-01',
    requisitionFor: 'Service',
    procurementMethod: 'Open Tender',
    lineItems: [
      {
        id: 'l2',
        product: 'Annual Training Program',
        qty: 1,
        rate: 15000,
        estimatedCost: 15000,
        specification: 'Leadership training for 50 employees',
      },
    ],
    total: 15000,
    budgetAllocated: 30000,
    budgetAvailable: 15000,
    status: 'Submitted',
    submissionDate: '2023-10-05',
  },
  {
    id: '3',
    prNo: 'PR-2023-003',
    originator: 'Lisa Chen',
    departmentCode: 'FIN-03',
    project: 'PRJ-FIN-300',
    priority: 'Low',
    estimatedDeliveryDate: '2024-01-10',
    requisitionFor: 'Goods',
    procurementMethod: 'Short Purchase',
    lineItems: [
      {
        id: 'l3',
        product: 'A4 Printer Paper',
        qty: 200,
        rate: 25,
        estimatedCost: 5000,
        specification: '80gsm white',
      },
      {
        id: 'l4',
        product: 'Ink Cartridges',
        qty: 50,
        rate: 45,
        estimatedCost: 2250,
        specification: 'HP 61XL Black',
      },
    ],
    total: 7250,
    budgetAllocated: 20000,
    budgetAvailable: 12750,
    status: 'Approved',
    submissionDate: '2023-10-08',
  },
  {
    id: '4',
    prNo: 'PR-2023-004',
    originator: 'James Wilson',
    departmentCode: 'OPS-04',
    project: 'PRJ-OPS-400',
    priority: 'High',
    estimatedDeliveryDate: '2023-11-30',
    requisitionFor: 'Works',
    procurementMethod: 'Open Tender',
    lineItems: [
      {
        id: 'l5',
        product: 'Industrial Generator 50kW',
        qty: 2,
        rate: 25000,
        estimatedCost: 50000,
        specification: 'Diesel, auto-start, weatherproof',
      },
    ],
    total: 50000,
    budgetAllocated: 100000,
    budgetAvailable: 50000,
    status: 'Approved',
    submissionDate: '2023-10-10',
  },
  {
    id: '5',
    prNo: 'PR-2023-005',
    originator: 'Priya Sharma',
    departmentCode: 'MKT-05',
    project: 'PRJ-MKT-500',
    priority: 'Medium',
    estimatedDeliveryDate: '2023-12-15',
    requisitionFor: 'Service',
    procurementMethod: 'Direct Purchase',
    lineItems: [
      {
        id: 'l6',
        product: 'Digital Marketing Campaign',
        qty: 1,
        rate: 35000,
        estimatedCost: 35000,
        specification: 'Q1 2024 social media + PPC',
      },
    ],
    total: 35000,
    budgetAllocated: 60000,
    budgetAvailable: 25000,
    status: 'Approved',
    submissionDate: '2023-10-12',
  },
  {
    id: '6',
    prNo: 'PR-2023-006',
    originator: 'Tom Hardy',
    departmentCode: 'IT-01',
    project: 'PRJ-IT-100',
    priority: 'High',
    estimatedDeliveryDate: '2024-01-05',
    requisitionFor: 'Goods',
    procurementMethod: 'Direct Purchase',
    lineItems: [
      {
        id: 'l7',
        product: 'Server Rack Unit',
        qty: 3,
        rate: 4500,
        estimatedCost: 13500,
        specification: '42U standard rack',
      },
      {
        id: 'l8',
        product: 'Network Switch 48-Port',
        qty: 5,
        rate: 800,
        estimatedCost: 4000,
        specification: 'Managed, PoE+',
      },
    ],
    total: 17500,
    budgetAllocated: 50000,
    budgetAvailable: 32500,
    status: 'Draft',
    submissionDate: '2023-10-15',
  },
  {
    id: '7',
    prNo: 'PR-2023-007',
    originator: 'Rachel Green',
    departmentCode: 'ADM-06',
    project: 'PRJ-ADM-600',
    priority: 'Low',
    estimatedDeliveryDate: '2024-02-01',
    requisitionFor: 'Goods',
    procurementMethod: 'Cash Purchase',
    lineItems: [
      {
        id: 'l9',
        product: 'Office Chairs - Ergonomic',
        qty: 25,
        rate: 350,
        estimatedCost: 8750,
        specification: 'Adjustable lumbar, mesh back',
      },
      {
        id: 'l10',
        product: 'Standing Desks',
        qty: 10,
        rate: 600,
        estimatedCost: 6000,
        specification: 'Electric height adjustable',
      },
    ],
    total: 14750,
    budgetAllocated: 25000,
    budgetAvailable: 10250,
    status: 'Approved',
    submissionDate: '2023-10-18',
  },
  {
    id: '8',
    prNo: 'PR-2023-008',
    originator: 'David Kim',
    departmentCode: 'ENG-07',
    project: 'PRJ-ENG-700',
    priority: 'High',
    estimatedDeliveryDate: '2023-12-20',
    requisitionFor: 'Service',
    procurementMethod: 'Open Tender',
    lineItems: [
      {
        id: 'l11',
        product: 'HVAC System Maintenance',
        qty: 1,
        rate: 22000,
        estimatedCost: 22000,
        specification: 'Annual contract, 4 quarterly inspections',
      },
    ],
    total: 22000,
    budgetAllocated: 40000,
    budgetAvailable: 18000,
    status: 'Rejected',
    submissionDate: '2023-10-20',
  },
  {
    id: '9',
    prNo: 'PR-2023-009',
    originator: 'Emily Davis',
    departmentCode: 'FIN-03',
    project: 'PRJ-FIN-300',
    priority: 'Medium',
    estimatedDeliveryDate: '2024-01-15',
    requisitionFor: 'Goods',
    procurementMethod: 'Short Purchase',
    lineItems: [
      {
        id: 'l12',
        product: 'Financial Software License',
        qty: 10,
        rate: 500,
        estimatedCost: 5000,
        specification: 'Annual subscription, cloud-based',
      },
    ],
    total: 5000,
    budgetAllocated: 15000,
    budgetAvailable: 10000,
    status: 'Approved',
    submissionDate: '2023-10-22',
  },
  {
    id: '10',
    prNo: 'PR-2023-010',
    originator: 'Carlos Mendez',
    departmentCode: 'SEC-08',
    project: 'PRJ-SEC-800',
    priority: 'High',
    estimatedDeliveryDate: '2023-11-25',
    requisitionFor: 'Works',
    procurementMethod: 'Direct Purchase',
    lineItems: [
      {
        id: 'l13',
        product: 'CCTV Camera System',
        qty: 20,
        rate: 450,
        estimatedCost: 9000,
        specification: '4K IP cameras with night vision',
      },
      {
        id: 'l14',
        product: 'NVR Recording Unit',
        qty: 2,
        rate: 2500,
        estimatedCost: 5000,
        specification: '32-channel, 8TB storage',
      },
    ],
    total: 14000,
    budgetAllocated: 25000,
    budgetAvailable: 11000,
    status: 'Approved',
    submissionDate: '2023-10-25',
  },
]

export const mockPOs: PurchaseOrder[] = [
  {
    id: '1',
    poNo: 'PO-2023-001',
    linkedPRNo: 'PR-2023-001',
    vendor: 'TechCorp Solutions',
    department: 'IT-01',
    project: 'PRJ-IT-100',
    procurementMethod: 'Direct Purchase',
    poDate: '2023-10-10',
    deliveryDate: '2023-11-15',
    lineItems: [
      {
        id: 'l1',
        product: 'Laptop Pro X',
        qty: 5,
        rate: 1200,
        estimatedCost: 6000,
        specification: '16GB RAM, 512GB SSD',
      },
    ],
    totalAmount: 6000,
    status: 'Approved',
    submissionDate: '2023-10-11',
    submittedBy: 'Admin User',
  },
  {
    id: '2',
    poNo: 'PO-2023-002',
    linkedPRNo: 'PR-2023-003',
    vendor: 'Office Supplies Co.',
    department: 'FIN-03',
    project: 'PRJ-FIN-300',
    procurementMethod: 'Short Purchase',
    poDate: '2023-10-15',
    deliveryDate: '2024-01-10',
    lineItems: [
      {
        id: 'l3',
        product: 'A4 Printer Paper',
        qty: 200,
        rate: 25,
        estimatedCost: 5000,
        specification: '80gsm white',
      },
      {
        id: 'l4',
        product: 'Ink Cartridges',
        qty: 50,
        rate: 45,
        estimatedCost: 2250,
        specification: 'HP 61XL Black',
      },
    ],
    totalAmount: 7250,
    status: 'Approved',
    submissionDate: '2023-10-16',
    submittedBy: 'Lisa Chen',
  },
  {
    id: '3',
    poNo: 'PO-2023-003',
    linkedPRNo: 'PR-2023-004',
    vendor: 'GreenEnergy Solutions',
    department: 'OPS-04',
    project: 'PRJ-OPS-400',
    procurementMethod: 'Open Tender',
    poDate: '2023-10-20',
    deliveryDate: '2023-11-30',
    lineItems: [
      {
        id: 'l5',
        product: 'Industrial Generator 50kW',
        qty: 2,
        rate: 25000,
        estimatedCost: 50000,
        specification: 'Diesel, auto-start, weatherproof',
      },
    ],
    totalAmount: 50000,
    status: 'Pending',
    submissionDate: '2023-10-21',
    submittedBy: 'James Wilson',
  },
  {
    id: '4',
    poNo: 'PO-2023-004',
    linkedPRNo: 'PR-2023-005',
    vendor: 'Apex IT Consulting',
    department: 'MKT-05',
    project: 'PRJ-MKT-500',
    procurementMethod: 'Direct Purchase',
    poDate: '2023-10-22',
    deliveryDate: '2023-12-15',
    lineItems: [
      {
        id: 'l6',
        product: 'Digital Marketing Campaign',
        qty: 1,
        rate: 35000,
        estimatedCost: 35000,
        specification: 'Q1 2024 social media + PPC',
      },
    ],
    totalAmount: 35000,
    status: 'Approved',
    submissionDate: '2023-10-23',
    submittedBy: 'Priya Sharma',
  },
  {
    id: '5',
    poNo: 'PO-2023-005',
    linkedPRNo: 'PR-2023-007',
    vendor: 'Nordic Furniture AB',
    department: 'ADM-06',
    project: 'PRJ-ADM-600',
    procurementMethod: 'Cash Purchase',
    poDate: '2023-10-25',
    deliveryDate: '2024-02-01',
    lineItems: [
      {
        id: 'l9',
        product: 'Office Chairs - Ergonomic',
        qty: 25,
        rate: 350,
        estimatedCost: 8750,
        specification: 'Adjustable lumbar, mesh back',
      },
      {
        id: 'l10',
        product: 'Standing Desks',
        qty: 10,
        rate: 600,
        estimatedCost: 6000,
        specification: 'Electric height adjustable',
      },
    ],
    totalAmount: 14750,
    status: 'Draft',
    submissionDate: '2023-10-26',
    submittedBy: 'Rachel Green',
  },
  {
    id: '6',
    poNo: 'PO-2023-006',
    linkedPRNo: 'PR-2023-009',
    vendor: 'TechCorp Solutions',
    department: 'FIN-03',
    project: 'PRJ-FIN-300',
    procurementMethod: 'Short Purchase',
    poDate: '2023-10-28',
    deliveryDate: '2024-01-15',
    lineItems: [
      {
        id: 'l12',
        product: 'Financial Software License',
        qty: 10,
        rate: 500,
        estimatedCost: 5000,
        specification: 'Annual subscription, cloud-based',
      },
    ],
    totalAmount: 5000,
    status: 'Pending',
    submissionDate: '2023-10-29',
    submittedBy: 'Emily Davis',
  },
  {
    id: '7',
    poNo: 'PO-2023-007',
    linkedPRNo: 'PR-2023-010',
    vendor: 'SafeGuard Security',
    department: 'SEC-08',
    project: 'PRJ-SEC-800',
    procurementMethod: 'Direct Purchase',
    poDate: '2023-11-01',
    deliveryDate: '2023-11-25',
    lineItems: [
      {
        id: 'l13',
        product: 'CCTV Camera System',
        qty: 20,
        rate: 450,
        estimatedCost: 9000,
        specification: '4K IP cameras with night vision',
      },
      {
        id: 'l14',
        product: 'NVR Recording Unit',
        qty: 2,
        rate: 2500,
        estimatedCost: 5000,
        specification: '32-channel, 8TB storage',
      },
    ],
    totalAmount: 14000,
    status: 'Approved',
    submissionDate: '2023-11-02',
    submittedBy: 'Carlos Mendez',
  },
  {
    id: '8',
    poNo: 'PO-2023-008',
    linkedPRNo: 'PR-2023-001',
    vendor: 'MedEquip International',
    department: 'IT-01',
    project: 'PRJ-IT-100',
    procurementMethod: 'Direct Purchase',
    poDate: '2023-11-05',
    deliveryDate: '2023-12-10',
    lineItems: [
      {
        id: 'l15',
        product: 'UPS Battery Backup 3kVA',
        qty: 10,
        rate: 800,
        estimatedCost: 8000,
        specification: 'Online double-conversion',
      },
    ],
    totalAmount: 8000,
    status: 'Rejected',
    submissionDate: '2023-11-06',
    submittedBy: 'Tom Hardy',
  },
  {
    id: '9',
    poNo: 'PO-2023-009',
    linkedPRNo: 'PR-2023-004',
    vendor: 'BuildIt Construction',
    department: 'OPS-04',
    project: 'PRJ-OPS-400',
    procurementMethod: 'Open Tender',
    poDate: '2023-11-08',
    deliveryDate: '2024-01-20',
    lineItems: [
      {
        id: 'l16',
        product: 'Warehouse Shelving System',
        qty: 50,
        rate: 320,
        estimatedCost: 16000,
        specification: 'Heavy-duty steel, 5-tier',
      },
    ],
    totalAmount: 16000,
    status: 'Pending',
    submissionDate: '2023-11-09',
    submittedBy: 'James Wilson',
  },
  {
    id: '10',
    poNo: 'PO-2023-010',
    linkedPRNo: 'PR-2023-005',
    vendor: 'QuickPrint Services',
    department: 'MKT-05',
    project: 'PRJ-MKT-500',
    procurementMethod: 'Direct Purchase',
    poDate: '2023-11-10',
    deliveryDate: '2023-12-01',
    lineItems: [
      {
        id: 'l17',
        product: 'Marketing Brochures Print',
        qty: 5000,
        rate: 2,
        estimatedCost: 10000,
        specification: 'Full color, A4 tri-fold, glossy',
      },
    ],
    totalAmount: 10000,
    status: 'Draft',
    submissionDate: '2023-11-11',
    submittedBy: 'Priya Sharma',
  },
]

export const mockProducts: Product[] = [
  {
    id: '1',
    productCode: 'PROD-001',
    productName: 'Laptop Pro X',
    productType: 'Finished Goods',
    category: 'Goods',
    subCategory: 'Electronics',
    unitOfMeasure: 'pcs',
    defaultRate: 1200,
    warranty: '1 Year',
    warehouse: 'Main Hub',
    minStockLevel: 10,
    reorderPoint: 15,
    reorderQuantity: 20,
    alertChannels: ['Email', 'In-app'],
    alertFrequency: 'Immediate',
    status: 'Active',
  },
  {
    id: '2',
    productCode: 'PROD-002',
    productName: 'A4 Printer Paper',
    productType: 'Consumable',
    category: 'Goods',
    subCategory: 'Stationery',
    unitOfMeasure: 'box',
    defaultRate: 25,
    warehouse: 'Office Store',
    minStockLevel: 50,
    reorderPoint: 60,
    reorderQuantity: 100,
    alertChannels: ['Email'],
    alertFrequency: 'Daily Digest',
    status: 'Active',
  },
  {
    id: '3',
    productCode: 'PROD-003',
    productName: 'Ink Cartridges HP 61XL',
    productType: 'Consumable',
    category: 'Goods',
    subCategory: 'Stationery',
    unitOfMeasure: 'pcs',
    defaultRate: 45,
    warehouse: 'Office Store',
    minStockLevel: 20,
    reorderPoint: 30,
    reorderQuantity: 50,
    alertChannels: ['Email'],
    alertFrequency: 'Daily Digest',
    status: 'Active',
  },
  {
    id: '4',
    productCode: 'PROD-004',
    productName: 'Network Switch 48-Port',
    productType: 'Finished Goods',
    category: 'Goods',
    subCategory: 'Networking',
    unitOfMeasure: 'pcs',
    defaultRate: 800,
    warranty: '3 Years',
    warehouse: 'Main Hub',
    minStockLevel: 5,
    reorderPoint: 8,
    reorderQuantity: 10,
    alertChannels: ['Email', 'In-app'],
    alertFrequency: 'Immediate',
    status: 'Active',
  },
  {
    id: '5',
    productCode: 'PROD-005',
    productName: 'UPS Battery Backup 3kVA',
    productType: 'Finished Goods',
    category: 'Goods',
    subCategory: 'Electronics',
    unitOfMeasure: 'pcs',
    defaultRate: 800,
    warranty: '2 Years',
    warehouse: 'Main Hub',
    minStockLevel: 3,
    reorderPoint: 5,
    reorderQuantity: 10,
    alertChannels: ['Email', 'In-app'],
    alertFrequency: 'Immediate',
    status: 'Active',
  },
  {
    id: '6',
    productCode: 'PROD-006',
    productName: 'Office Chairs - Ergonomic',
    productType: 'Finished Goods',
    category: 'Goods',
    subCategory: 'Furniture',
    unitOfMeasure: 'pcs',
    defaultRate: 350,
    warranty: '5 Years',
    warehouse: 'Warehouse B',
    minStockLevel: 10,
    reorderPoint: 15,
    reorderQuantity: 25,
    alertChannels: ['Email'],
    alertFrequency: 'Weekly',
    status: 'Active',
  },
  {
    id: '7',
    productCode: 'PROD-007',
    productName: 'Standing Desks',
    productType: 'Finished Goods',
    category: 'Goods',
    subCategory: 'Furniture',
    unitOfMeasure: 'pcs',
    defaultRate: 600,
    warranty: '3 Years',
    warehouse: 'Warehouse B',
    minStockLevel: 5,
    reorderPoint: 8,
    reorderQuantity: 10,
    alertChannels: ['Email'],
    alertFrequency: 'Weekly',
    status: 'Active',
  },
  {
    id: '8',
    productCode: 'PROD-008',
    productName: 'Safety Helmets',
    productType: 'Consumable',
    category: 'Goods',
    subCategory: 'Safety Equipment',
    unitOfMeasure: 'pcs',
    defaultRate: 35,
    warehouse: 'Main Hub',
    minStockLevel: 50,
    reorderPoint: 75,
    reorderQuantity: 100,
    alertChannels: ['Email', 'In-app'],
    alertFrequency: 'Immediate',
    status: 'Active',
  },
  {
    id: '9',
    productCode: 'PROD-009',
    productName: 'Cleaning Supplies Kit',
    productType: 'Consumable',
    category: 'Goods',
    subCategory: 'Janitorial',
    unitOfMeasure: 'kit',
    defaultRate: 75,
    warehouse: 'Office Store',
    minStockLevel: 20,
    reorderPoint: 30,
    reorderQuantity: 40,
    alertChannels: ['Email'],
    alertFrequency: 'Daily Digest',
    status: 'Inactive',
  },
  {
    id: '10',
    productCode: 'PROD-010',
    productName: 'Projector HD 4K',
    productType: 'Finished Goods',
    category: 'Goods',
    subCategory: 'Electronics',
    unitOfMeasure: 'pcs',
    defaultRate: 2500,
    warranty: '2 Years',
    warehouse: 'Main Hub',
    minStockLevel: 2,
    reorderPoint: 3,
    reorderQuantity: 5,
    alertChannels: ['Email', 'In-app'],
    alertFrequency: 'Immediate',
    status: 'Active',
  },
]

export const mockAssets = [
  {
    id: '1',
    assetCode: 'AST-001',
    assetName: 'Office Desk - Executive',
    category: 'Furniture',
    defaultRate: 850,
  },
  {
    id: '2',
    assetCode: 'AST-002',
    assetName: 'Projector HD 4K',
    category: 'Electronics',
    defaultRate: 2500,
  },
  {
    id: '3',
    assetCode: 'AST-003',
    assetName: 'Server Rack Unit',
    category: 'IT Infrastructure',
    defaultRate: 4500,
  },
  {
    id: '4',
    assetCode: 'AST-004',
    assetName: 'Air Conditioning Unit',
    category: 'Facility Equipment',
    defaultRate: 3200,
  },
  {
    id: '5',
    assetCode: 'AST-005',
    assetName: 'Industrial Generator 50kW',
    category: 'Power Systems',
    defaultRate: 25000,
  },
  {
    id: '6',
    assetCode: 'AST-006',
    assetName: 'CCTV Camera System',
    category: 'Security',
    defaultRate: 450,
  },
  {
    id: '7',
    assetCode: 'AST-007',
    assetName: 'NVR Recording Unit',
    category: 'Security',
    defaultRate: 2500,
  },
  {
    id: '8',
    assetCode: 'AST-008',
    assetName: 'Conference Table - 12 Seat',
    category: 'Furniture',
    defaultRate: 1800,
  },
  {
    id: '9',
    assetCode: 'AST-009',
    assetName: 'Electric Vehicle Charger',
    category: 'Facility Equipment',
    defaultRate: 5500,
  },
  {
    id: '10',
    assetCode: 'AST-010',
    assetName: 'Warehouse Shelving System',
    category: 'Storage',
    defaultRate: 320,
  },
]

export const mockRequisitions: Requisition[] = [
  {
    id: '1',
    reqNo: 'REQ-2023-001',
    department: 'Sales',
    reqFor: 'Office Use',
    requestedBy: 'Jim Halpert',
    requiredDate: '2023-10-20',
    items: [
      {
        id: 'i1',
        item: 'A4 Printer Paper',
        qty: 5,
        purpose: 'Q4 Reports printing',
      },
    ],
    totalItems: 1,
    status: 'Approved',
    submissionDate: '2023-10-15',
    approvalLevel: 'Department Head',
  },
  {
    id: '2',
    reqNo: 'REQ-2023-002',
    department: 'Marketing',
    reqFor: 'Office Use',
    requestedBy: 'Pam Beesly',
    requiredDate: '2023-10-25',
    items: [
      {
        id: 'i2',
        item: 'Ink Cartridges',
        qty: 10,
        purpose: 'Brochure printing',
      },
      {
        id: 'i3',
        item: 'Glossy Paper A3',
        qty: 50,
        purpose: 'Poster printing',
      },
    ],
    totalItems: 2,
    status: 'Submitted',
    submissionDate: '2023-10-17',
    approvalLevel: 'Department Head',
  },
  {
    id: '3',
    reqNo: 'REQ-2023-003',
    department: 'Engineering',
    reqFor: 'Office Use',
    requestedBy: 'Dwight Schrute',
    requiredDate: '2023-11-01',
    items: [
      {
        id: 'i4',
        item: 'Safety Helmets',
        qty: 20,
        purpose: 'Site inspection team',
      },
    ],
    totalItems: 1,
    status: 'Approved',
    submissionDate: '2023-10-18',
    approvalLevel: 'Operations Manager',
  },
  {
    id: '4',
    reqNo: 'REQ-2023-004',
    department: 'IT',
    reqFor: 'Employee Use',
    employee: 'Ryan Howard',
    requestedBy: 'Ryan Howard',
    requiredDate: '2023-10-28',
    items: [
      {
        id: 'i5',
        item: 'Laptop Charger',
        qty: 1,
        purpose: 'Replacement for damaged charger',
      },
    ],
    totalItems: 1,
    status: 'Draft',
    submissionDate: '2023-10-19',
  },
  {
    id: '5',
    reqNo: 'REQ-2023-005',
    department: 'Finance',
    reqFor: 'Office Use',
    requestedBy: 'Angela Martin',
    requiredDate: '2023-11-05',
    items: [
      {
        id: 'i6',
        item: 'Calculator - Scientific',
        qty: 5,
        purpose: 'Audit team',
      },
      { id: 'i7', item: 'File Folders', qty: 100, purpose: 'Year-end filing' },
    ],
    totalItems: 2,
    status: 'Approved',
    submissionDate: '2023-10-20',
    approvalLevel: 'Department Head',
  },
  {
    id: '6',
    reqNo: 'REQ-2023-006',
    department: 'HR',
    reqFor: 'Office Use',
    requestedBy: 'Toby Flenderson',
    requiredDate: '2023-11-10',
    items: [
      {
        id: 'i8',
        item: 'Cleaning Supplies Kit',
        qty: 10,
        purpose: 'Monthly office cleaning',
      },
    ],
    totalItems: 1,
    status: 'Rejected',
    submissionDate: '2023-10-21',
    approvalLevel: 'Department Head',
  },
  {
    id: '7',
    reqNo: 'REQ-2023-007',
    department: 'Operations',
    reqFor: 'Office Use',
    requestedBy: 'Darryl Philbin',
    requiredDate: '2023-11-15',
    items: [
      {
        id: 'i9',
        item: 'Packing Tape',
        qty: 50,
        purpose: 'Warehouse shipping',
      },
      {
        id: 'i10',
        item: 'Bubble Wrap Rolls',
        qty: 20,
        purpose: 'Fragile item packaging',
      },
    ],
    totalItems: 2,
    status: 'Submitted',
    submissionDate: '2023-10-22',
    approvalLevel: 'Operations Manager',
  },
  {
    id: '8',
    reqNo: 'REQ-2023-008',
    department: 'IT',
    reqFor: 'Employee Use',
    employee: 'Kevin Malone',
    requestedBy: 'Kevin Malone',
    requiredDate: '2023-11-08',
    items: [
      {
        id: 'i11',
        item: 'Wireless Mouse',
        qty: 1,
        purpose: 'Ergonomic upgrade',
      },
    ],
    totalItems: 1,
    status: 'Approved',
    submissionDate: '2023-10-23',
    approvalLevel: 'IT Manager',
  },
  {
    id: '9',
    reqNo: 'REQ-2023-009',
    department: 'Security',
    reqFor: 'Office Use',
    requestedBy: 'Hank Tate',
    requiredDate: '2023-11-20',
    items: [
      {
        id: 'i12',
        item: 'Flashlights',
        qty: 10,
        purpose: 'Night patrol equipment',
      },
      {
        id: 'i13',
        item: 'Two-Way Radios',
        qty: 5,
        purpose: 'Security team communication',
      },
    ],
    totalItems: 2,
    status: 'Submitted',
    submissionDate: '2023-10-24',
    approvalLevel: 'Security Manager',
  },
  {
    id: '10',
    reqNo: 'REQ-2023-010',
    department: 'Admin',
    reqFor: 'Office Use',
    requestedBy: 'Erin Hannon',
    requiredDate: '2023-11-12',
    items: [
      {
        id: 'i14',
        item: 'Whiteboard Markers',
        qty: 30,
        purpose: 'Meeting rooms',
      },
      {
        id: 'i15',
        item: 'Sticky Notes',
        qty: 50,
        purpose: 'Office supplies restock',
      },
      {
        id: 'i16',
        item: 'Desk Organizers',
        qty: 15,
        purpose: 'New employee onboarding',
      },
    ],
    totalItems: 3,
    status: 'Approved',
    submissionDate: '2023-10-25',
    approvalLevel: 'Department Head',
  },
]

export const mockReceives: ReceiveEntry[] = [
  {
    id: '1',
    receiveNo: 'RCV-2023-001',
    linkedPONo: 'PO-2023-001',
    vendor: 'TechCorp Solutions',
    department: 'IT-01',
    project: 'PRJ-IT-100',
    procurementMethod: 'Direct Purchase',
    receiveDate: '2023-11-14',
    deliveryChallanNo: 'DC-998877',
    lineItems: [
      {
        id: 'l1',
        product: 'Laptop Pro X',
        orderedQty: 5,
        previouslyReceivedQty: 0,
        receivingQty: 5,
        pendingQty: 0,
        rate: 1200,
        lineAmount: 6000,
      },
    ],
    totalReceiveAmount: 6000,
    status: 'Processed',
    createdBy: 'Store Officer',
  },
  {
    id: '2',
    receiveNo: 'RCV-2023-002',
    linkedPONo: 'PO-2023-002',
    vendor: 'Office Supplies Co.',
    department: 'FIN-03',
    project: 'PRJ-FIN-300',
    procurementMethod: 'Short Purchase',
    receiveDate: '2023-11-20',
    deliveryChallanNo: 'DC-112233',
    lineItems: [
      {
        id: 'l3',
        product: 'A4 Printer Paper',
        orderedQty: 200,
        previouslyReceivedQty: 0,
        receivingQty: 150,
        pendingQty: 50,
        rate: 25,
        lineAmount: 3750,
      },
      {
        id: 'l4',
        product: 'Ink Cartridges',
        orderedQty: 50,
        previouslyReceivedQty: 0,
        receivingQty: 50,
        pendingQty: 0,
        rate: 45,
        lineAmount: 2250,
      },
    ],
    totalReceiveAmount: 6000,
    status: 'Processed',
    createdBy: 'Store Officer',
  },
  {
    id: '3',
    receiveNo: 'RCV-2023-003',
    linkedPONo: 'PO-2023-002',
    vendor: 'Office Supplies Co.',
    department: 'FIN-03',
    project: 'PRJ-FIN-300',
    procurementMethod: 'Short Purchase',
    receiveDate: '2023-12-05',
    deliveryChallanNo: 'DC-112234',
    lineItems: [
      {
        id: 'l3b',
        product: 'A4 Printer Paper',
        orderedQty: 200,
        previouslyReceivedQty: 150,
        receivingQty: 50,
        pendingQty: 0,
        rate: 25,
        lineAmount: 1250,
      },
    ],
    totalReceiveAmount: 1250,
    status: 'Processed',
    createdBy: 'Store Officer',
  },
  {
    id: '4',
    receiveNo: 'RCV-2023-004',
    linkedPONo: 'PO-2023-004',
    vendor: 'Apex IT Consulting',
    department: 'MKT-05',
    project: 'PRJ-MKT-500',
    procurementMethod: 'Direct Purchase',
    receiveDate: '2023-12-10',
    deliveryChallanNo: 'DC-445566',
    lineItems: [
      {
        id: 'l6',
        product: 'Digital Marketing Campaign',
        orderedQty: 1,
        previouslyReceivedQty: 0,
        receivingQty: 1,
        pendingQty: 0,
        rate: 35000,
        lineAmount: 35000,
      },
    ],
    totalReceiveAmount: 35000,
    status: 'Submitted',
    createdBy: 'Marketing Coordinator',
  },
  {
    id: '5',
    receiveNo: 'RCV-2023-005',
    linkedPONo: 'PO-2023-007',
    vendor: 'SafeGuard Security',
    department: 'SEC-08',
    project: 'PRJ-SEC-800',
    procurementMethod: 'Direct Purchase',
    receiveDate: '2023-11-22',
    deliveryChallanNo: 'DC-778899',
    lineItems: [
      {
        id: 'l13',
        product: 'CCTV Camera System',
        orderedQty: 20,
        previouslyReceivedQty: 0,
        receivingQty: 15,
        pendingQty: 5,
        rate: 450,
        lineAmount: 6750,
      },
      {
        id: 'l14',
        product: 'NVR Recording Unit',
        orderedQty: 2,
        previouslyReceivedQty: 0,
        receivingQty: 2,
        pendingQty: 0,
        rate: 2500,
        lineAmount: 5000,
      },
    ],
    totalReceiveAmount: 11750,
    status: 'Processed',
    createdBy: 'Security Admin',
  },
  {
    id: '6',
    receiveNo: 'RCV-2023-006',
    linkedPONo: 'PO-2023-007',
    vendor: 'SafeGuard Security',
    department: 'SEC-08',
    project: 'PRJ-SEC-800',
    procurementMethod: 'Direct Purchase',
    receiveDate: '2023-12-01',
    deliveryChallanNo: 'DC-778900',
    lineItems: [
      {
        id: 'l13b',
        product: 'CCTV Camera System',
        orderedQty: 20,
        previouslyReceivedQty: 15,
        receivingQty: 5,
        pendingQty: 0,
        rate: 450,
        lineAmount: 2250,
      },
    ],
    totalReceiveAmount: 2250,
    status: 'Draft',
    createdBy: 'Security Admin',
  },
  {
    id: '7',
    receiveNo: 'RCV-2023-007',
    linkedPONo: 'PO-2023-005',
    vendor: 'Nordic Furniture AB',
    department: 'ADM-06',
    project: 'PRJ-ADM-600',
    procurementMethod: 'Cash Purchase',
    receiveDate: '2024-01-15',
    deliveryChallanNo: 'DC-334455',
    lineItems: [
      {
        id: 'l9',
        product: 'Office Chairs - Ergonomic',
        orderedQty: 25,
        previouslyReceivedQty: 0,
        receivingQty: 25,
        pendingQty: 0,
        rate: 350,
        lineAmount: 8750,
      },
      {
        id: 'l10',
        product: 'Standing Desks',
        orderedQty: 10,
        previouslyReceivedQty: 0,
        receivingQty: 10,
        pendingQty: 0,
        rate: 600,
        lineAmount: 6000,
      },
    ],
    totalReceiveAmount: 14750,
    status: 'Submitted',
    createdBy: 'Admin Officer',
  },
  {
    id: '8',
    receiveNo: 'RCV-2023-008',
    linkedPONo: 'PO-2023-003',
    vendor: 'GreenEnergy Solutions',
    department: 'OPS-04',
    project: 'PRJ-OPS-400',
    procurementMethod: 'Open Tender',
    receiveDate: '2023-11-28',
    deliveryChallanNo: 'DC-667788',
    lineItems: [
      {
        id: 'l5',
        product: 'Industrial Generator 50kW',
        orderedQty: 2,
        previouslyReceivedQty: 0,
        receivingQty: 1,
        pendingQty: 1,
        rate: 25000,
        lineAmount: 25000,
      },
    ],
    totalReceiveAmount: 25000,
    status: 'Processed',
    createdBy: 'Operations Manager',
  },
  {
    id: '9',
    receiveNo: 'RCV-2023-009',
    linkedPONo: 'PO-2023-003',
    vendor: 'GreenEnergy Solutions',
    department: 'OPS-04',
    project: 'PRJ-OPS-400',
    procurementMethod: 'Open Tender',
    receiveDate: '2023-12-15',
    deliveryChallanNo: 'DC-667789',
    lineItems: [
      {
        id: 'l5b',
        product: 'Industrial Generator 50kW',
        orderedQty: 2,
        previouslyReceivedQty: 1,
        receivingQty: 1,
        pendingQty: 0,
        rate: 25000,
        lineAmount: 25000,
      },
    ],
    totalReceiveAmount: 25000,
    status: 'Draft',
    createdBy: 'Operations Manager',
  },
  {
    id: '10',
    receiveNo: 'RCV-2023-010',
    linkedPONo: 'PO-2023-006',
    vendor: 'TechCorp Solutions',
    department: 'FIN-03',
    project: 'PRJ-FIN-300',
    procurementMethod: 'Short Purchase',
    receiveDate: '2024-01-10',
    deliveryChallanNo: 'DC-990011',
    lineItems: [
      {
        id: 'l12',
        product: 'Financial Software License',
        orderedQty: 10,
        previouslyReceivedQty: 0,
        receivingQty: 10,
        pendingQty: 0,
        rate: 500,
        lineAmount: 5000,
      },
    ],
    totalReceiveAmount: 5000,
    status: 'Submitted',
    createdBy: 'Finance Officer',
  },
]

export const mockQCEntries: QCEntry[] = [
  {
    id: '1',
    qcReferenceNo: 'QC-2023-001',
    linkedReceiveNo: 'RCV-2023-001',
    linkedPONo: 'PO-2023-001',
    vendor: 'TechCorp Solutions',
    product: 'Laptop Pro X',
    warehouse: 'Main Hub',
    poQty: 5,
    receiveQty: 5,
    quantity: 5,
    qcInspector: 'Quality Manager',
    qcStatus: 'Passed',
    inspectionDate: '2023-11-15',
    acceptedQty: 5,
    rejectedQty: 0,
    qcRemarks: 'All units passed diagnostic tests.',
  },
  {
    id: '2',
    qcReferenceNo: 'QC-2023-002',
    linkedReceiveNo: 'RCV-2023-007',
    linkedPONo: 'PO-2023-005',
    vendor: 'Nordic Furniture AB',
    product: 'Office Chairs - Ergonomic',
    warehouse: 'Warehouse B',
    poQty: 25,
    receiveQty: 25,
    quantity: 25,
    qcInspector: 'Quality Manager',
    qcStatus: 'Failed',
    inspectionDate: '2023-11-16',
    acceptedQty: 23,
    rejectedQty: 2,
    qcRemarks: '2 chairs have broken wheel mechanisms.',
  },
  {
    id: '3',
    qcReferenceNo: 'QC-2023-003',
    linkedReceiveNo: 'RCV-2023-002',
    linkedPONo: 'PO-2023-002',
    vendor: 'Office Supplies Co.',
    product: 'A4 Printer Paper',
    warehouse: 'Office Store',
    poQty: 200,
    receiveQty: 150,
    quantity: 150,
    qcInspector: 'Store Supervisor',
    qcStatus: 'Passed',
    inspectionDate: '2023-11-21',
    acceptedQty: 150,
    rejectedQty: 0,
    qcRemarks: 'All boxes in good condition, correct weight.',
  },
  {
    id: '4',
    qcReferenceNo: 'QC-2023-004',
    linkedReceiveNo: 'RCV-2023-002',
    linkedPONo: 'PO-2023-002',
    vendor: 'Office Supplies Co.',
    product: 'Ink Cartridges',
    warehouse: 'Office Store',
    poQty: 50,
    receiveQty: 50,
    quantity: 50,
    qcInspector: 'Store Supervisor',
    qcStatus: 'Passed',
    inspectionDate: '2023-11-21',
    acceptedQty: 48,
    rejectedQty: 2,
    qcRemarks: '2 cartridges had damaged seals, rest OK.',
  },
  {
    id: '5',
    qcReferenceNo: 'QC-2023-005',
    linkedReceiveNo: 'RCV-2023-005',
    linkedPONo: 'PO-2023-007',
    vendor: 'SafeGuard Security',
    product: 'CCTV Camera System',
    warehouse: 'Main Hub',
    poQty: 20,
    receiveQty: 15,
    quantity: 15,
    qcInspector: 'IT Quality Lead',
    qcStatus: 'Passed',
    inspectionDate: '2023-11-23',
    acceptedQty: 15,
    rejectedQty: 0,
    qcRemarks: 'All cameras tested for video quality and night vision.',
  },
  {
    id: '6',
    qcReferenceNo: 'QC-2023-006',
    linkedReceiveNo: 'RCV-2023-005',
    linkedPONo: 'PO-2023-007',
    vendor: 'SafeGuard Security',
    product: 'NVR Recording Unit',
    warehouse: 'Main Hub',
    poQty: 2,
    receiveQty: 2,
    quantity: 2,
    qcInspector: 'IT Quality Lead',
    qcStatus: 'Passed',
    inspectionDate: '2023-11-23',
    acceptedQty: 2,
    rejectedQty: 0,
    qcRemarks: 'Both units functional, storage verified.',
  },
  {
    id: '7',
    qcReferenceNo: 'QC-2023-007',
    linkedReceiveNo: 'RCV-2023-008',
    linkedPONo: 'PO-2023-003',
    vendor: 'GreenEnergy Solutions',
    product: 'Industrial Generator 50kW',
    warehouse: 'Main Hub',
    poQty: 2,
    receiveQty: 1,
    quantity: 1,
    qcInspector: 'Engineering QC',
    qcStatus: 'Passed',
    inspectionDate: '2023-11-29',
    acceptedQty: 1,
    rejectedQty: 0,
    qcRemarks: 'Load test passed at 100% capacity.',
  },
  {
    id: '8',
    qcReferenceNo: 'QC-2023-008',
    linkedReceiveNo: 'RCV-2023-007',
    linkedPONo: 'PO-2023-005',
    vendor: 'Nordic Furniture AB',
    product: 'Standing Desks',
    warehouse: 'Warehouse B',
    poQty: 10,
    receiveQty: 10,
    quantity: 10,
    qcInspector: 'Quality Manager',
    qcStatus: 'Pending',
    inspectionDate: '2024-01-16',
    acceptedQty: 0,
    rejectedQty: 0,
    qcRemarks: 'Awaiting inspection after delivery.',
  },
  {
    id: '9',
    qcReferenceNo: 'QC-2023-009',
    linkedReceiveNo: 'RCV-2023-008',
    linkedPONo: 'PO-2023-008',
    vendor: 'MedEquip International',
    product: 'UPS Battery Backup 3kVA',
    warehouse: 'Main Hub',
    poQty: 10,
    receiveQty: 10,
    quantity: 10,
    qcInspector: 'IT Quality Lead',
    qcStatus: 'Failed',
    inspectionDate: '2023-12-12',
    acceptedQty: 7,
    rejectedQty: 3,
    qcRemarks:
      '3 units failed battery charge retention test. Returned to vendor.',
  },
  {
    id: '10',
    qcReferenceNo: 'QC-2023-010',
    linkedReceiveNo: 'RCV-2023-010',
    linkedPONo: 'PO-2023-006',
    vendor: 'TechCorp Solutions',
    product: 'Financial Software License',
    warehouse: 'Main Hub',
    poQty: 10,
    receiveQty: 10,
    quantity: 10,
    qcInspector: 'IT Manager',
    qcStatus: 'Passed',
    inspectionDate: '2024-01-11',
    acceptedQty: 10,
    rejectedQty: 0,
    qcRemarks: 'All license keys validated and activated successfully.',
  },
]

export const mockApprovals: ProcurementApproval[] = [
  {
    id: '1',
    refNo: 'EOI-2023-001',
    title: 'IT Infrastructure Upgrade',
    method: 'Open Tender',
    submissionDate: '2023-09-01',
    submittedBy: 'IT Director',
    status: 'Approved',
  },
  {
    id: '2',
    refNo: 'RFP-2023-001',
    title: 'Cloud Migration Services',
    method: 'Direct Purchase',
    submissionDate: '2023-09-15',
    submittedBy: 'Cloud Architect',
    status: 'Pending',
  },
  {
    id: '3',
    refNo: 'NOA-2023-001',
    title: 'Office Renovation',
    method: 'Open Tender',
    submissionDate: '2023-10-01',
    submittedBy: 'Facilities Manager',
    status: 'Approved',
    supplier: 'BuildIt Construction',
    amount: 150000,
  },
  {
    id: '4',
    refNo: 'EOI-2023-002',
    title: 'Annual Security Services',
    method: 'Open Tender',
    submissionDate: '2023-10-05',
    submittedBy: 'Security Director',
    status: 'Approved',
  },
  {
    id: '5',
    refNo: 'RFP-2023-002',
    title: 'Generator Procurement',
    method: 'Open Tender',
    submissionDate: '2023-10-10',
    submittedBy: 'Operations Manager',
    status: 'Approved',
    supplier: 'GreenEnergy Solutions',
    amount: 50000,
  },
  {
    id: '6',
    refNo: 'RFQ-2023-001',
    title: 'Office Furniture Refresh',
    method: 'Short Purchase',
    submissionDate: '2023-10-12',
    submittedBy: 'Admin Manager',
    status: 'Pending',
  },
  {
    id: '7',
    refNo: 'NOA-2023-002',
    title: 'Digital Marketing Contract',
    method: 'Direct Purchase',
    submissionDate: '2023-10-18',
    submittedBy: 'Marketing Director',
    status: 'Approved',
    supplier: 'Apex IT Consulting',
    amount: 35000,
  },
  {
    id: '8',
    refNo: 'EOI-2023-003',
    title: 'HVAC Maintenance Contract',
    method: 'Open Tender',
    submissionDate: '2023-10-20',
    submittedBy: 'Engineering Manager',
    status: 'Rejected',
  },
  {
    id: '9',
    refNo: 'RFP-2023-003',
    title: 'CCTV & Surveillance System',
    method: 'Direct Purchase',
    submissionDate: '2023-10-25',
    submittedBy: 'Security Director',
    status: 'Approved',
    supplier: 'SafeGuard Security',
    amount: 14000,
  },
  {
    id: '10',
    refNo: 'NOA-2023-003',
    title: 'Financial Software Licensing',
    method: 'Short Purchase',
    submissionDate: '2023-10-28',
    submittedBy: 'Finance Director',
    status: 'Pending',
    supplier: 'TechCorp Solutions',
    amount: 5000,
  },
]

export const mockStockEntries: StockEntry[] = [
  {
    id: '1',
    transactionNo: 'STK-2023-001',
    type: 'Stock In',
    date: '2023-11-14',
    product: 'Laptop Pro X',
    productCode: 'PROD-001',
    warehouse: 'Main Hub',
    quantity: 5,
    unitOfMeasure: 'pcs',
    referenceType: 'PO Receive',
    referenceNo: 'RCV-2023-001',
    performedBy: 'Store Officer',
    remarks: 'Received from TechCorp Solutions against PO-2023-001',
    status: 'Completed',
  },
  {
    id: '2',
    transactionNo: 'STK-2023-002',
    type: 'Stock In',
    date: '2023-11-20',
    product: 'A4 Printer Paper',
    productCode: 'PROD-002',
    warehouse: 'Office Store',
    quantity: 150,
    unitOfMeasure: 'box',
    referenceType: 'PO Receive',
    referenceNo: 'RCV-2023-002',
    performedBy: 'Store Officer',
    remarks: 'Partial delivery — 150 of 200 boxes received',
    status: 'Completed',
  },
  {
    id: '3',
    transactionNo: 'STK-2023-003',
    type: 'Stock Out',
    date: '2023-11-22',
    product: 'A4 Printer Paper',
    productCode: 'PROD-002',
    warehouse: 'Office Store',
    quantity: 5,
    unitOfMeasure: 'box',
    referenceType: 'Requisition',
    referenceNo: 'REQ-2023-001',
    performedBy: 'Store Officer',
    remarks: 'Issued to Sales department for Q4 Reports',
    status: 'Completed',
  },
  {
    id: '4',
    transactionNo: 'STK-2023-004',
    type: 'Stock In',
    date: '2023-11-22',
    product: 'CCTV Camera System',
    productCode: 'PROD-011',
    warehouse: 'Main Hub',
    quantity: 15,
    unitOfMeasure: 'pcs',
    referenceType: 'PO Receive',
    referenceNo: 'RCV-2023-005',
    performedBy: 'Security Admin',
    remarks: 'First batch — 15 of 20 cameras received',
    status: 'Completed',
  },
  {
    id: '5',
    transactionNo: 'STK-2023-005',
    type: 'Stock Out',
    date: '2023-11-25',
    product: 'Laptop Pro X',
    productCode: 'PROD-001',
    warehouse: 'Main Hub',
    quantity: 2,
    unitOfMeasure: 'pcs',
    referenceType: 'Requisition',
    referenceNo: 'REQ-2023-004',
    performedBy: 'IT Manager',
    remarks: 'Issued to new employees in IT department',
    status: 'Completed',
  },
  {
    id: '6',
    transactionNo: 'STK-2023-006',
    type: 'Stock Out',
    date: '2023-11-28',
    product: 'Ink Cartridges HP 61XL',
    productCode: 'PROD-003',
    warehouse: 'Office Store',
    quantity: 10,
    unitOfMeasure: 'pcs',
    referenceType: 'Requisition',
    referenceNo: 'REQ-2023-002',
    performedBy: 'Store Officer',
    remarks: 'Issued to Marketing for brochure printing',
    status: 'Completed',
  },
  {
    id: '7',
    transactionNo: 'STK-2023-007',
    type: 'Stock In',
    date: '2023-12-01',
    product: 'CCTV Camera System',
    productCode: 'PROD-011',
    warehouse: 'Main Hub',
    quantity: 5,
    unitOfMeasure: 'pcs',
    referenceType: 'PO Receive',
    referenceNo: 'RCV-2023-006',
    performedBy: 'Security Admin',
    remarks: 'Remaining 5 cameras received',
    status: 'Completed',
  },
  {
    id: '8',
    transactionNo: 'STK-2023-008',
    type: 'Stock Out',
    date: '2023-12-05',
    product: 'Safety Helmets',
    productCode: 'PROD-008',
    warehouse: 'Main Hub',
    quantity: 20,
    unitOfMeasure: 'pcs',
    referenceType: 'Requisition',
    referenceNo: 'REQ-2023-003',
    performedBy: 'Store Officer',
    remarks: 'Issued to Engineering for site inspection team',
    status: 'Completed',
  },
  {
    id: '9',
    transactionNo: 'STK-2023-009',
    type: 'Stock Out',
    date: '2023-12-12',
    product: 'UPS Battery Backup 3kVA',
    productCode: 'PROD-005',
    warehouse: 'Main Hub',
    quantity: 3,
    unitOfMeasure: 'pcs',
    referenceType: 'Disposal',
    referenceNo: 'DSP-2023-001',
    performedBy: 'IT Quality Lead',
    remarks: 'Failed QC — returned to vendor for replacement',
    status: 'Completed',
  },
  {
    id: '10',
    transactionNo: 'STK-2023-010',
    type: 'Stock In',
    date: '2023-12-15',
    product: 'A4 Printer Paper',
    productCode: 'PROD-002',
    warehouse: 'Office Store',
    quantity: 50,
    unitOfMeasure: 'box',
    referenceType: 'PO Receive',
    referenceNo: 'RCV-2023-003',
    performedBy: 'Store Officer',
    remarks: 'Remaining 50 boxes from PO-2023-002',
    status: 'Completed',
  },
]

export const mockStockTransfers: StockTransfer[] = [
  {
    id: '1',
    transferNo: 'TRF-2023-001',
    date: '2023-11-18',
    product: 'Laptop Pro X',
    productCode: 'PROD-001',
    fromWarehouse: 'Main Hub',
    toWarehouse: 'Office Store',
    quantity: 2,
    unitOfMeasure: 'pcs',
    reason: 'IT department setup at branch office',
    performedBy: 'Store Officer',
    remarks: 'Transferred for new employee onboarding at branch',
    status: 'Completed',
  },
  {
    id: '2',
    transferNo: 'TRF-2023-002',
    date: '2023-11-22',
    product: 'A4 Printer Paper',
    productCode: 'PROD-002',
    fromWarehouse: 'Office Store',
    toWarehouse: 'Warehouse B',
    quantity: 30,
    unitOfMeasure: 'box',
    reason: 'Restock branch warehouse',
    performedBy: 'Store Officer',
    remarks: 'Monthly restock for Warehouse B printing needs',
    status: 'Completed',
  },
  {
    id: '3',
    transferNo: 'TRF-2023-003',
    date: '2023-11-25',
    product: 'Safety Helmets',
    productCode: 'PROD-008',
    fromWarehouse: 'Main Hub',
    toWarehouse: 'Warehouse B',
    quantity: 15,
    unitOfMeasure: 'pcs',
    reason: 'Construction site safety requirement',
    performedBy: 'Operations Manager',
    remarks: 'Urgent transfer for new construction project',
    status: 'Completed',
  },
  {
    id: '4',
    transferNo: 'TRF-2023-004',
    date: '2023-12-01',
    product: 'Ink Cartridges HP 61XL',
    productCode: 'PROD-003',
    fromWarehouse: 'Office Store',
    toWarehouse: 'Main Hub',
    quantity: 10,
    unitOfMeasure: 'pcs',
    reason: 'Consolidation of supplies',
    performedBy: 'Store Officer',
    remarks: 'Moving excess stock to central warehouse',
    status: 'Completed',
  },
  {
    id: '5',
    transferNo: 'TRF-2023-005',
    date: '2023-12-05',
    product: 'Office Chairs - Ergonomic',
    productCode: 'PROD-006',
    fromWarehouse: 'Warehouse B',
    toWarehouse: 'Main Hub',
    quantity: 5,
    unitOfMeasure: 'pcs',
    reason: 'Office renovation — furniture relocation',
    performedBy: 'Admin Officer',
    remarks: 'Chairs needed for renovated 3rd floor',
    status: 'Completed',
  },
  {
    id: '6',
    transferNo: 'TRF-2023-006',
    date: '2023-12-10',
    product: 'Network Switch 48-Port',
    productCode: 'PROD-004',
    fromWarehouse: 'Main Hub',
    toWarehouse: 'Warehouse B',
    quantity: 2,
    unitOfMeasure: 'pcs',
    reason: 'Network infrastructure expansion',
    performedBy: 'IT Manager',
    remarks: 'Setting up network at new warehouse section',
    status: 'In Transit',
  },
  {
    id: '7',
    transferNo: 'TRF-2023-007',
    date: '2023-12-12',
    product: 'UPS Battery Backup 3kVA',
    productCode: 'PROD-005',
    fromWarehouse: 'Main Hub',
    toWarehouse: 'Office Store',
    quantity: 3,
    unitOfMeasure: 'pcs',
    reason: 'Power backup for office servers',
    performedBy: 'IT Manager',
    remarks: 'Critical — office experienced power outages',
    status: 'Pending',
  },
  {
    id: '8',
    transferNo: 'TRF-2023-008',
    date: '2023-12-15',
    product: 'Cleaning Supplies Kit',
    productCode: 'PROD-009',
    fromWarehouse: 'Office Store',
    toWarehouse: 'Warehouse B',
    quantity: 5,
    unitOfMeasure: 'kit',
    reason: 'Warehouse maintenance supplies',
    performedBy: 'Store Officer',
    remarks: 'Quarterly cleaning supplies distribution',
    status: 'Draft',
  },
  {
    id: '9',
    transferNo: 'TRF-2023-009',
    date: '2023-12-18',
    product: 'Projector HD 4K',
    productCode: 'PROD-010',
    fromWarehouse: 'Main Hub',
    toWarehouse: 'Office Store',
    quantity: 1,
    unitOfMeasure: 'pcs',
    reason: 'Conference room setup',
    performedBy: 'Admin Officer',
    remarks: 'New conference room at branch office',
    status: 'Pending',
  },
  {
    id: '10',
    transferNo: 'TRF-2023-010',
    date: '2023-12-20',
    product: 'Standing Desks',
    productCode: 'PROD-007',
    fromWarehouse: 'Warehouse B',
    toWarehouse: 'Main Hub',
    quantity: 3,
    unitOfMeasure: 'pcs',
    reason: 'Employee workspace upgrade',
    performedBy: 'Admin Officer',
    remarks: 'Approved ergonomic upgrade for finance team',
    status: 'Cancelled',
  },
]

export const mockPublishedTenders: PublishedTender[] = [
  {
    id: '1',
    refNo: 'EOI-2024-001',
    title: 'IT Infrastructure Upgrade — Data Center Expansion',
    description:
      'Expression of Interest for vendors to provide data center hardware, networking equipment, and installation services for the headquarters expansion project.',
    category: 'Service',
    method: 'Open Tender',
    publishDate: '2024-01-05',
    submissionDeadline: '2024-02-05',
    status: 'Open',
    department: 'IT Department',
    estimatedBudget: 500000,
  },
  {
    id: '2',
    refNo: 'EOI-2024-002',
    title: 'Office Furniture Supply — New Branch Setup',
    description:
      'Seeking qualified suppliers for ergonomic office furniture including desks, chairs, and storage units for the new branch office.',
    category: 'Goods',
    method: 'Open Tender',
    publishDate: '2024-01-10',
    submissionDeadline: '2024-02-10',
    status: 'Open',
    department: 'Administration',
    estimatedBudget: 120000,
  },
  {
    id: '3',
    refNo: 'EOI-2024-003',
    title: 'Annual Security Services Contract',
    description:
      'EOI for security firms to provide 24/7 manned guarding, CCTV monitoring, and access control management across all company facilities.',
    category: 'Service',
    method: 'Open Tender',
    publishDate: '2024-01-12',
    submissionDeadline: '2024-02-15',
    status: 'Open',
    department: 'Security',
    estimatedBudget: 350000,
  },
  {
    id: '4',
    refNo: 'EOI-2024-004',
    title: 'Warehouse Construction — Phase 2',
    description:
      'Expression of Interest for construction companies to build a 5,000 sqm warehouse facility including loading docks and climate control systems.',
    category: 'Works',
    method: 'Open Tender',
    publishDate: '2024-01-15',
    submissionDeadline: '2024-02-28',
    status: 'Open',
    department: 'Operations',
    estimatedBudget: 2000000,
  },
  {
    id: '5',
    refNo: 'EOI-2024-005',
    title: 'Fleet Vehicle Procurement',
    description:
      'Seeking suppliers for 15 commercial delivery vehicles with GPS tracking and fleet management system integration.',
    category: 'Goods',
    method: 'Open Tender',
    publishDate: '2024-01-18',
    submissionDeadline: '2024-03-01',
    status: 'Open',
    department: 'Logistics',
    estimatedBudget: 750000,
  },
  {
    id: '6',
    refNo: 'EOI-2023-010',
    title: 'Cloud Migration Services',
    description:
      'EOI for cloud service providers to migrate on-premise infrastructure to cloud-based solutions.',
    category: 'Service',
    method: 'Open Tender',
    publishDate: '2023-10-01',
    submissionDeadline: '2023-11-01',
    status: 'Closed',
    department: 'IT Department',
    estimatedBudget: 200000,
  },
  {
    id: '7',
    refNo: 'EOI-2023-008',
    title: 'Cleaning & Janitorial Services',
    description:
      'Annual contract for professional cleaning services across all office locations.',
    category: 'Service',
    method: 'Open Tender',
    publishDate: '2023-09-15',
    submissionDeadline: '2023-10-15',
    status: 'Awarded',
    department: 'Administration',
    estimatedBudget: 80000,
  },
  {
    id: '8',
    refNo: 'EOI-2024-006',
    title: 'Medical Equipment Supply',
    description:
      'EOI for suppliers of diagnostic medical equipment for the company health center upgrade.',
    category: 'Goods',
    method: 'Open Tender',
    publishDate: '2024-01-20',
    submissionDeadline: '2024-03-10',
    status: 'Open',
    department: 'Health & Safety',
    estimatedBudget: 300000,
  },
  {
    id: '9',
    refNo: 'EOI-2023-009',
    title: 'HVAC System Maintenance',
    description:
      'Annual maintenance contract for heating, ventilation, and air conditioning systems.',
    category: 'Service',
    method: 'Open Tender',
    publishDate: '2023-11-01',
    submissionDeadline: '2023-12-01',
    status: 'Closed',
    department: 'Engineering',
    estimatedBudget: 45000,
  },
  {
    id: '10',
    refNo: 'EOI-2024-007',
    title: 'Employee Training Platform',
    description:
      'Seeking vendors to provide a comprehensive digital learning management system with content creation tools.',
    category: 'Service',
    method: 'Open Tender',
    publishDate: '2024-01-22',
    submissionDeadline: '2024-03-15',
    status: 'Open',
    department: 'Human Resources',
    estimatedBudget: 150000,
  },
]

export const mockSupplierRFPs: SupplierRFP[] = [
  {
    id: '1',
    rfpRefNo: 'RFP-2024-001',
    title: 'IT Infrastructure Upgrade — Data Center Expansion',
    description:
      'You have been invited to submit a proposal for data center hardware and installation services.',
    invitationDate: '2024-02-06',
    submissionDeadline: '2024-03-06',
    status: 'Pending Submission',
  },
  {
    id: '2',
    rfpRefNo: 'RFP-2024-002',
    title: 'Cloud Migration Services',
    description:
      'Submit your proposal for migrating on-premise infrastructure to cloud-based solutions.',
    invitationDate: '2023-11-05',
    submissionDeadline: '2023-12-05',
    status: 'Submitted',
    submittedDate: '2023-11-28',
    quotedAmount: 185000,
  },
  {
    id: '3',
    rfpRefNo: 'RFP-2024-003',
    title: 'Annual Security Services Contract',
    description:
      'Proposal invitation for 24/7 security services including manned guarding and CCTV monitoring.',
    invitationDate: '2024-02-16',
    submissionDeadline: '2024-03-16',
    status: 'Pending Submission',
  },
  {
    id: '4',
    rfpRefNo: 'RFP-2023-010',
    title: 'Cleaning & Janitorial Services',
    description:
      'Your proposal for annual cleaning services has been evaluated.',
    invitationDate: '2023-10-16',
    submissionDeadline: '2023-11-16',
    status: 'Awarded',
    submittedDate: '2023-11-10',
    quotedAmount: 72000,
  },
  {
    id: '5',
    rfpRefNo: 'RFP-2023-011',
    title: 'Office Stationery Supply — Annual Contract',
    description:
      'Your proposal for office stationery supply has been evaluated.',
    invitationDate: '2023-09-01',
    submissionDeadline: '2023-10-01',
    status: 'Not Selected',
    submittedDate: '2023-09-25',
    quotedAmount: 35000,
  },
  {
    id: '6',
    rfpRefNo: 'RFP-2024-004',
    title: 'Employee Training Platform',
    description:
      'Submit your proposal for a digital learning management system.',
    invitationDate: '2024-02-20',
    submissionDeadline: '2024-03-20',
    status: 'Pending Submission',
  },
  {
    id: '7',
    rfpRefNo: 'RFP-2024-005',
    title: 'Fleet Vehicle Procurement',
    description:
      'Invitation to submit pricing and specifications for 15 commercial delivery vehicles.',
    invitationDate: '2024-03-02',
    submissionDeadline: '2024-04-02',
    status: 'Pending Submission',
  },
  {
    id: '8',
    rfpRefNo: 'RFP-2023-012',
    title: 'HVAC System Maintenance',
    description: 'Your maintenance proposal is currently under review.',
    invitationDate: '2023-12-02',
    submissionDeadline: '2024-01-02',
    status: 'Under Evaluation',
    submittedDate: '2023-12-28',
    quotedAmount: 42000,
  },
  {
    id: '9',
    rfpRefNo: 'RFP-2024-006',
    title: 'Medical Equipment Supply',
    description:
      'Submit your proposal for diagnostic medical equipment for the health center.',
    invitationDate: '2024-03-11',
    submissionDeadline: '2024-04-11',
    status: 'Pending Submission',
  },
  {
    id: '10',
    rfpRefNo: 'RFP-2024-007',
    title: 'Warehouse Construction — Phase 2',
    description:
      'Invitation to submit construction proposal for 5,000 sqm warehouse facility.',
    invitationDate: '2024-03-01',
    submissionDeadline: '2024-04-15',
    status: 'Pending Submission',
  },
]

export const masterDataSets: Record<string, MasterDataItem[]> = {
  warehouses: [
    {
      id: '1',
      code: 'WH-001',
      name: 'Main Hub',
      description: 'Central warehouse and primary storage facility',
      status: 'Active',
    },
    {
      id: '2',
      code: 'WH-002',
      name: 'Office Store',
      description: 'Office supplies and stationery storage',
      status: 'Active',
    },
    {
      id: '3',
      code: 'WH-003',
      name: 'Warehouse B',
      description: 'Secondary warehouse for overflow and bulk storage',
      status: 'Active',
    },
    {
      id: '4',
      code: 'WH-004',
      name: 'Cold Storage',
      description: 'Temperature-controlled storage for perishables',
      status: 'Inactive',
    },
    {
      id: '5',
      code: 'WH-005',
      name: 'IT Equipment Store',
      description: 'Dedicated storage for IT hardware and peripherals',
      status: 'Active',
    },
  ],
  departments: [
    {
      id: '1',
      code: 'IT-01',
      name: 'Information Technology',
      description: 'IT infrastructure, systems, and support',
      status: 'Active',
    },
    {
      id: '2',
      code: 'HR-02',
      name: 'Human Resources',
      description: 'Employee management, recruitment, and training',
      status: 'Active',
    },
    {
      id: '3',
      code: 'FIN-03',
      name: 'Finance',
      description: 'Financial planning, accounting, and budgeting',
      status: 'Active',
    },
    {
      id: '4',
      code: 'OPS-04',
      name: 'Operations',
      description: 'Day-to-day operational management',
      status: 'Active',
    },
    {
      id: '5',
      code: 'MKT-05',
      name: 'Marketing',
      description: 'Marketing campaigns and brand management',
      status: 'Active',
    },
    {
      id: '6',
      code: 'ADM-06',
      name: 'Administration',
      description: 'General administration and office management',
      status: 'Active',
    },
    {
      id: '7',
      code: 'ENG-07',
      name: 'Engineering',
      description: 'Engineering projects and technical services',
      status: 'Active',
    },
    {
      id: '8',
      code: 'SEC-08',
      name: 'Security',
      description: 'Physical and information security',
      status: 'Active',
    },
    {
      id: '9',
      code: 'LOG-09',
      name: 'Logistics',
      description: 'Supply chain and logistics management',
      status: 'Active',
    },
    {
      id: '10',
      code: 'HSE-10',
      name: 'Health & Safety',
      description: 'Workplace health, safety, and environment',
      status: 'Inactive',
    },
  ],
  categories: [
    {
      id: '1',
      code: 'CAT-001',
      name: 'Goods',
      description: 'Physical products and materials',
      status: 'Active',
    },
    {
      id: '2',
      code: 'CAT-002',
      name: 'Service',
      description: 'Professional and technical services',
      status: 'Active',
    },
    {
      id: '3',
      code: 'CAT-003',
      name: 'Works',
      description: 'Construction and civil works',
      status: 'Active',
    },
    {
      id: '4',
      code: 'CAT-004',
      name: 'Others',
      description: 'Miscellaneous and uncategorized items',
      status: 'Active',
    },
    {
      id: '5',
      code: 'CAT-005',
      name: 'Consulting',
      description: 'Advisory and consulting services',
      status: 'Inactive',
    },
  ],
  'units-of-measure': [
    {
      id: '1',
      code: 'UOM-001',
      name: 'pcs',
      description: 'Pieces — individual units',
      status: 'Active',
    },
    {
      id: '2',
      code: 'UOM-002',
      name: 'box',
      description: 'Box — standard packaging unit',
      status: 'Active',
    },
    {
      id: '3',
      code: 'UOM-003',
      name: 'kit',
      description: 'Kit — bundled set of items',
      status: 'Active',
    },
    {
      id: '4',
      code: 'UOM-004',
      name: 'kg',
      description: 'Kilogram — weight measurement',
      status: 'Active',
    },
    {
      id: '5',
      code: 'UOM-005',
      name: 'ltr',
      description: 'Litre — volume measurement',
      status: 'Active',
    },
    {
      id: '6',
      code: 'UOM-006',
      name: 'mtr',
      description: 'Metre — length measurement',
      status: 'Active',
    },
    {
      id: '7',
      code: 'UOM-007',
      name: 'set',
      description: 'Set — grouped collection',
      status: 'Active',
    },
    {
      id: '8',
      code: 'UOM-008',
      name: 'roll',
      description: 'Roll — rolled material unit',
      status: 'Inactive',
    },
  ],
}
